<template>
  <div>
    <div v-if="showFilters" style="text-align:center;">
      <el-radio-group v-model="selectedFilter" size="mini" @change="handleFilters">
        <el-radio-button v-for="(filter, index) in filters"  :key="index" :label="filter" border>{{$t('reservations.filters.' +filter)}}</el-radio-button>
      </el-radio-group>
    </div>
    <el-table
      :data="reservationsFiltered"
      stripe
      style="width: 100%;"
      v-loading="loading"
      :cell-style="{padding:'2px'}">
      <div slot="empty">
        <span>{{$t('reservation.noReservation')}}</span>
      </div>
      <el-table-column
        width="35">
        <template slot-scope="scope">
          <status-indicator class=""
          :negative="isNegative(scope.row.nbDays)"
          :intermediary="isIntermediary(scope.row.nbDays)"
          :positive="isPositive(scope.row.nbDays)"
          v-if="showDelayIndicator(scope.row)"
            pulse
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.date')" prop="created_at" sortable width="100">
        <template slot-scope="scope">
          <span style="word-break:break-word;" v-if="scope.row.date">{{_moment(scope.row.date)}}</span>
          <span v-if="scope.row.delayed">{{$t('reservation.toCome')}}</span>
          <span v-if="scope.row.intent">{{$t('reservation.intent')}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reservation.reservationNumber')" sortable prop="id" width="100">
        <template slot-scope="scope" >
          <PortausLink path="/reservations/" :id="scope.row.id" :label="scope.row.id.toString()"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column v-if="showCustomer" :label="$t('reservation.customer')" prop="customer.usual_name" sortable show-overflow-tooltip>
        <template slot-scope="scope">
          <PortausLink path="/customers/" :id="scope.row.customer.id" :label="customerName(scope.row.customer)"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column v-if="showRep" :label="$t('reservation.rep')" sortable prop="sales_rep.first_name" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="word-break:break-word;" v-if="scope.row.rep">{{scope.row.rep.firstName}} {{scope.row.rep.lastName}}</span>
          </template>
      </el-table-column>
      <el-table-column :label="$t('reservation.product')" prop="product.name" sortable show-overflow-tooltip v-if="showProduct && showProductName">
      </el-table-column>
      <el-table-column  :label="$t('reservation.provider')" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.product.provider != null">
          <PortausLink path="/customers/" :id="scope.row.product.provider.id" :label="customerName(scope.row.product.provider)"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column :label="$t('reservation.reserved')" prop="qty" sortable width="105" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.quantity.reserved}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('reservation.used')" prop="quantity.used" sortable width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$t('reservation.available')" prop="quantity.available" sortable width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="nb_days"
        show-overflow-tooltip
        :label="$t('reservation.age')"
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.date">{{scope.row.nbDays}} {{$t('reservation.days')}}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import ReservationAPI from '@/services/API/reservation.js'
import PortausLink from '@/components/portaus-link'
import { mapActions, mapState, mapGetters } from 'vuex';
import CustomerUtil from '@/utils/customer-util';

export default {
  name: 'reservation-table-standalone',
	props: {
    customerId : Number,
    puid: String,
    productId : Number,
    inventoryId: Number,
    showRep : {
      type : Boolean,
      default : true,
    },
    showProductName: {
      type: Boolean,
      default: true
    },
    showFilters: {
      type: Boolean,
      default: false
    },
    defaultFilter: {
      type: String,
      default: "AVAILABLE"
    }
	},
  data() {
    return {
      reservations : [],
      loading : false,
      filters: ['AVAILABLE', 'TO_COME', 'SOLD', 'INTENT'],
      selectedFilter: null,
    };
  },components: {
    PortausLink
  },
  watch : {
    puid: function (newVal, oldVal) {
      this.fetchReservations();
    },
    productId : function (newVal, oldVal) {
      this.fetchReservations();
    },
    customerId : function (newVal, oldVal) {
      this.fetchReservations();
    },
    inventoryId : function (newVal, oldVal) {
      this.fetchReservations();
    }
  },
  computed: {
    reservationsFiltered () {
      if (this.showFilters) {
        if (this.selectedFilter === 'AVAILABLE') {
          return _.filter(this.reservations, r => _.get(r, 'quantity.available') > 0 && r.delayed === false && r.intent === false);
        } else if (this.selectedFilter === 'TO_COME'){
          return _.filter(this.reservations, r => r.delayed === true);
        } else if (this.selectedFilter === 'INTENT'){
          return _.filter(this.reservations, r => r.intent === true);
        } else if (this.selectedFilter === 'SOLD'){
          return _.filter(this.reservations, r => _.get(r, 'quantity.available') <= 0 && r.intent === false && r.delayed === false);
        }

      }
      return this.reservations;
    },
    showCustomer () {
      return this.customerId == null;
    },
    showProduct () {
      return this.productId == null;
    },
    ...mapGetters('reservations', ['isNegative','isIntermediary','isPositive'])
  },
	methods: {
    showDelayIndicator(reservation) {
      let show = true;

      if (reservation.intent === false && reservation.delayed === false && reservation.quantity.available <= 0) {
        show = false;
      }
      return show;
    },
    handleFilters (value) {
      this.selectedFilter = value;
    },
    fetchReservations() {
      this.loading = true;
      let filters = {
        puid: this.puid != null ? this.puid : undefined,
        customerId: this.customerId != null ? this.customerId : undefined,
        productId: this.productId != null ? this.productId : undefined,
        inventoryId: this.inventoryId != null ? this.inventoryId : undefined,
        paging: 'no',
        orderBy: 'created_at',
        direction: 'DESC',
      }
      return ReservationAPI.fetchReservationsV2(filters)
        .then((reservations) => {
          this.reservations = reservations;
          this.loading = false;
        })
    },
    customerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usualName);
    },
    _diffDate(dateTimeFrom, measure='days',dateTimeToDefault=null){
    let dateTimeTo = dateTimeToDefault==null?moment():moment(dateTimeTo, measure);
    return moment(dateTimeFrom).diff(dateTimeTo, measure);
    },
    formatNbJours(nbJours){
      if(nbJours==0){
        return "Aujourd'hui";
      }else{
        if(nbJours<0) return (nbJours*-1)+ " jours";
        return nbJours+ " jours";
      }
    },
    _moment(datetime, format='l'){
      return moment(datetime).format(format);
    },
	},
  mounted(){
    this.fetchReservations();
    this.selectedFilter = this.defaultFilter;
  }
}
</script>
<style lang="scss" scoped>




</style>
